export default {"src":"/_next/static/media/AquinasLogo.145fcd79.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};